import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Services from '../services/Services'
import swal from 'sweetalert'
import { Cart } from '../components/Cart'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Rating from '@mui/material/Rating'
import { Button, Modal } from 'react-bootstrap'
import K from '../services/k'

import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'

import OrderComponent from '../components/order/Order'

import {
  faDolly,
  faEnvelope,
  faPhoneSquare,
  faStarHalfAlt,
  faUnlockAlt,
  faUser,
  faUserCog,
} from '@fortawesome/free-solid-svg-icons'
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      key={index}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

function MyAccount(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  let resinfo = ''

  const services = new Services(this)

  const authResponse = useSelector((state) => state.userAuth.authResponse)
  const [orderHistories, setOrderHistories] = useState([])
  const [orderPrepMeals, setOrderPrepMeals] = useState([])
  const [user, setUser] = useState({})

  const [currentOrder, setCurrentOrder] = useState(null)
  const [currentRating, setCurrentRating] = useState({
    restaurant: {
      score: 0,
      description: '',
    },
    driver: {
      score: 0,
      description: '',
    },
  })

  const [password, setPassword] = useState('')
  const [names, setNames] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const getMealName = (item) => {
    return item?.order_items[0]?.meal_name
  }

  const getQuantity = (item) => {
    return item?.order_items.length
  }

  const getPrice = (item) => {
    let totalPrice = 0
    item.order_items.map((it) => {
      totalPrice += it.price
    })
    return totalPrice
  }

  const updateUser = (form) => {
    form.preventDefault()
    const namesList = names.split(' ')

    const data = {
      firstname: namesList[0],
      lastname: namesList[1],
      email: email,
      phone: phone,
      password: confirmPassword,
    }
    return services.updateUser(data).then(() => {
      swal({
        title: 'Success!',
        text: 'Profile Updated!',
        icon: 'success',
        timer: 1500,
      })
    })
  }

  useEffect(() => {
    if (authResponse !== '' && authResponse.success === true) {
      alert(authResponse.message)
      localStorage.removeItem('user-token')
      //history.push("/user/login");
    }
    return () => {}
  }, [authResponse])

  useEffect(() => {
    services.getHistory().then((data) => {
      if (data.resultcode === 1) {
        setOrderHistories(data.order_history)
      }
    })

    services.fetchUser().then((data) => {
      if (data.resultcode === 1) {
        const user = data.user[0]
        setUser(user)
        setEmail(user.email)
        setPhone(user.phone)
        setNames(`${user.firstname} ${user.lastname}`)
        services.getPrepMealHistory().then((data) => {
          if (data.data) {
            setOrderPrepMeals(data.data)
          }
        })
      }
    })
  }, [])

  const handleClose = () => {
    setCurrentOrder(null)
  }

  const performRateItem = () => {
    if (
      currentRating === null ||
      currentOrder === null ||
      currentOrder.order_details === null ||
      currentRating.restaurant.score === 0 ||
      currentRating.driver.score === 0
    ) {
      return
    }

    const driverRating = currentOrder.order_details?.review.filter((el) => {
      return el.type === 1
    })[0]
    const restaurantRating = currentOrder.order_details?.review.filter((el) => {
      return el.type === 0
    })[0]

    const restaurantReview = {
      restaurant_order_id: currentOrder.order_details.id,
      description: currentRating.restaurant.description,
      score: currentRating.restaurant.score,
      type: 0,
      reviewer_id: user.id,
      review_id: restaurantRating?.id,
    }

    const driverReview = {
      restaurant_order_id: currentOrder.order_details.id,
      description: currentRating.driver.description,
      score: currentRating.driver.score,
      type: 1,
      reviewer_id: user.id,
      review_id: driverRating?.id,
    }
    const promises = []
    if (restaurantRating?.id) {
      promises.push(services.updateRating(restaurantReview))
    } else {
      promises.push(services.rateItem(restaurantReview))
    }
    if (driverRating?.id) {
      promises.push(services.updateRating(driverReview))
    } else {
      promises.push(services.rateItem(driverReview))
    }

    Promise.all(promises)
      .then(() => {
        handleClose()
        swal({
          title: 'Success!',
          text: 'Order rated!',
          icon: 'success',
          timer: 1500,
        })
        services.getHistory().then((data) => {
          if (data.resultcode === 1) {
            setOrderHistories(data.order_history)
          }
        })
      })
      .catch(() => {})
  }
  const tabMenus = [
    {
      tabname: 'Order',
      id: 'tab-Order',
      path: '#pane-Order',
      className: 'nav-link active',
      data: 'tab',
      role: 'tab',
      icon: faDolly,
    },
    {
      tabname: 'Review',
      id: 'tab-Review',
      path: '#pane-Review',
      className: 'nav-link',
      data: 'tab',
      role: 'tab',
      icon: faStarHalfAlt,
    },
    {
      tabname: 'Account-Setting',
      id: 'tab-Account-Setting',
      path: '#pane-Account-Setting',
      className: 'nav-link',
      data: 'tab',
      role: 'tab',
      icon: faUserCog,
    },
  ]

  const [value, setValue] = React.useState(0)

  const [orderHistoriesActive, setOrderHistoriesActive] = useState([])
  const [orderHistoriesDelivered, setOrderHistoriesDelivered] = useState([])

  const handleActiveOrders = () => {
    let _orderHistories = []

    orderHistories.map((data) => {
      if (
        data.order_details.status === 'submitted' ||
        data.order_details.status === 'accepted' ||
        data.order_details.status === 'ready' ||
        data.order_details.status === 'enroute_to_merchant' ||
        data.order_details.status === 'enroute_to_customer' ||
        data.order_details.status === 'arrived_at_customer' ||
        data.order_details.status === 'dispatched'
      ) {
        _orderHistories.push(data)
      }
    })

    //update State.
    setOrderHistoriesActive(_orderHistories)
  }
  const handleDeliveredOrders = () => {
    let _orderHistories = []
    orderHistories.map((data) => {
      if (
        data.order_details.status !== 'submitted' &&
        data.order_details.status !== 'accepted' &&
        data.order_details.status !== 'ready' &&
        data.order_details.status !== 'enroute_to_merchant' &&
        data.order_details.status !== 'enroute_to_customer' &&
        data.order_details.status !== 'arrived_at_customer' &&
        data.order_details.status !== 'dispatched'
      ) {
        _orderHistories.push(data)
      }
    })

    //update State.
    setOrderHistoriesDelivered(_orderHistories)
  }

  useEffect(() => {
    handleActiveOrders()
    handleDeliveredOrders()
  }, [orderHistories])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page myaccount">
        <section className="category-tabs">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 col-md-12 col-sm-12">
                <div className="row">
                  <div className="col-sm-3">
                    <ul id="tabs" className="nav nav-tabs" role="tablist">
                      <li>
                        <h3>Account</h3>
                      </li>
                      {tabMenus.map((menu, index) => (
                        <li className="nav-item" key={'nav' + index}>
                          <a
                            id={menu.id}
                            href={menu.path}
                            className={menu.className}
                            data-toggle={menu.data}
                            role={menu.role}
                          >
                            <FontAwesomeIcon icon={menu.icon} />
                            <i> </i> {menu.tabname}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-sm-9">
                    <div id="content" className="tab-content" role="tablist">
                      <div
                        id="pane-Order"
                        className="card tab-pane fade show active"
                        role="tabpanel"
                        aria-labelledby="tab-Order"
                      >
                        <div
                          className="card-header"
                          role="tab"
                          id="heading-Order"
                        >
                          <h5 className="mb-0">
                            {/* <!-- Note: `data-parent` removed from here --> */}
                            <a
                              data-toggle="collapse"
                              href="#collapse-Order"
                              aria-expanded="true"
                              aria-controls="collapse-Order"
                            >
                              Order
                            </a>
                          </h5>
                        </div>
                        {/* <!-- Note: New place of `data-parent` --> */}
                        <div
                          id="collapse-Order"
                          className="collapse"
                          data-parent="#content"
                          role="tabpanel"
                          aria-labelledby="heading-Order"
                        >
                          <div className="card-body">
                            <div className="row category-listing">
                              <Box sx={{ width: '100%' }}>
                                <Box
                                  sx={{
                                    borderBottom: 1,
                                    borderColor: 'divider',
                                  }}
                                >
                                  <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="basic tabs example"
                                    centered
                                    textColor="primary"
                                    indicatorColor="primary"
                                    variant="fullWidth"
                                  >
                                    <Tab label="Active" {...a11yProps(0)} />
                                    <Tab label="History" {...a11yProps(1)} />
                                    <Tab label="Scheduled" {...a11yProps(2)} />
                                  </Tabs>
                                </Box>
                                <TabPanel value={value} key={0} index={0}>
                                  {orderHistoriesActive.length ? (
                                    orderHistoriesActive.map((item, index) => (
                                      <OrderComponent item={item} key={index} />
                                    ))
                                  ) : (
                                    <div className="noOrders">
                                      <h5 className="noOrdersHead Spaced">
                                        Opps!, you have no active orders.
                                      </h5>
                                      <p className="normalText Spaced">
                                        You can order your favourite meals{' '}
                                        <br />
                                        from your local{' '}
                                        <a href="/restaurants">
                                          <b className="colorgreen">
                                            Restaurants
                                          </b>
                                        </a>
                                      </p>
                                      <img
                                        src="/noOrders.svg"
                                        className="img img-responsive Spaced"
                                        style={{ width: '300px' }}
                                      />
                                      <p className="normalText Spaced">
                                        Once you order, your recent meals will
                                        appear here...
                                      </p>
                                    </div>
                                  )}
                                </TabPanel>
                                <TabPanel value={value} key={1} index={1}>
                                  {orderHistoriesDelivered.length ? (
                                    orderHistoriesDelivered.map(
                                      (item, index) => (
                                        <div
                                          className={'div_account_order'}
                                          key={index}
                                        >
                                          <OrderComponent
                                            item={item}
                                            key={index}
                                          />
                                        </div>
                                      ),
                                    )
                                  ) : (
                                    <div className="noOrders">
                                      <h5 className="noOrdersHead Spaced">
                                        Opps!, you have no delivered orders
                                        before.
                                      </h5>
                                      <p className="normalText Spaced">
                                        You can order your favourite meals
                                        <br />
                                        from your local
                                        <a href="/restaurants">
                                          <b className="colorgreen">
                                            Restaurants
                                          </b>
                                        </a>
                                      </p>
                                      <img
                                        src="/noOrders.svg"
                                        className="img img-responsive Spaced"
                                        style={{ width: '300px' }}
                                      />
                                      <p className="normalText Spaced">
                                        Once you order, your recent meals will
                                        appear here...
                                      </p>
                                    </div>
                                  )}
                                </TabPanel>
                                <TabPanel value={value} key={2} index={2}>
                                  {orderHistoriesDelivered.length ? (
                                    orderPrepMeals.map((item, index) => (
                                      <div
                                        className={'div_account_order'}
                                        key={index}
                                      >
                                        <OrderComponent
                                          item={item}
                                          prep_meal={1}
                                          key={index}
                                        />
                                      </div>
                                    ))
                                  ) : (
                                    <div className="noOrders">
                                      <h5 className="noOrdersHead Spaced">
                                        Opps!, you have no delivered orders
                                        before.
                                      </h5>
                                      <p className="normalText Spaced">
                                        You can order your favourite meals
                                        <br />
                                        from your local
                                        <a href="/restaurants">
                                          <b className="colorgreen">
                                            Restaurants
                                          </b>
                                        </a>
                                      </p>
                                      <img
                                        src="/noOrders.svg"
                                        className="img img-responsive Spaced"
                                        style={{ width: '300px' }}
                                      />
                                      <p className="normalText Spaced">
                                        Once you order, your recent meals will
                                        appear here...
                                      </p>
                                    </div>
                                  )}
                                </TabPanel>
                              </Box>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="pane-Account-Setting"
                        className="card tab-pane fade"
                        role="tabpanel"
                        aria-labelledby="tab-Account-Setting"
                      >
                        <div
                          className="card-header"
                          role="tab"
                          id="heading-Account-Setting"
                        >
                          <h5 className="mb-0">
                            <a
                              data-toggle="collapse"
                              href="#collapse-Account-Setting"
                              aria-expanded="true"
                              aria-controls="collapse-Account-Setting"
                            >
                              Account Setting
                            </a>
                          </h5>
                        </div>
                        {/* <!-- Note: New place of `data-parent` --> */}
                        <div
                          id="collapse-Account-Setting"
                          className="collapse"
                          data-parent="#content"
                          role="tabpanel"
                          aria-labelledby="heading-Account-Setting"
                        >
                          <div className="card-body">
                            <form>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-container">
                                    <FontAwesomeIcon
                                      style={{
                                        position: 'absolute',
                                        margin: '30px 15px',
                                      }}
                                      icon={faUser}
                                    />
                                    <p className="normalText left">
                                      Client ID:
                                    </p>
                                    <input
                                      type="text"
                                      value={('00000' + user.id).slice(-5)}
                                      name="id"
                                      readOnly
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="form-container">
                                    <FontAwesomeIcon
                                      style={{
                                        position: 'absolute',
                                        margin: '30px 15px',
                                      }}
                                      icon={faUser}
                                    />
                                    <p className="normalText left">Names:</p>
                                    <input
                                      type="text"
                                      value={names}
                                      onChange={(event) => {
                                        setNames(event.target.value)
                                      }}
                                      name="yourname"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-container">
                                    <FontAwesomeIcon
                                      style={{
                                        position: 'absolute',
                                        margin: '30px 15px',
                                        transform: 'rotate(90deg)',
                                      }}
                                      icon={faPhoneSquare}
                                    />
                                    <p className="normalText left">Phone:</p>
                                    <input
                                      type="text"
                                      value={phone}
                                      onChange={(event) => {
                                        setPhone(event.target.value)
                                      }}
                                      name="phonenumber"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-container">
                                    <FontAwesomeIcon
                                      style={{
                                        position: 'absolute',
                                        margin: '30px 15px',
                                      }}
                                      icon={faEnvelope}
                                    />
                                    <p className="normalText left">Email:</p>
                                    <input
                                      type="email"
                                      value={email}
                                      onChange={(event) => {
                                        setEmail(event.target.value)
                                      }}
                                      name="emailAddress"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-container">
                                    <FontAwesomeIcon
                                      style={{
                                        position: 'absolute',
                                        margin: '30px 15px',
                                      }}
                                      icon={faUnlockAlt}
                                    />
                                    <p className="normalText left">Password:</p>
                                    <input
                                      type="text"
                                      value={password}
                                      onChange={(event) => {
                                        setPassword(event.target.value)
                                      }}
                                      name="yourname"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-container">
                                    <FontAwesomeIcon
                                      style={{
                                        position: 'absolute',
                                        margin: '30px 15px',
                                      }}
                                      icon={faUnlockAlt}
                                    />
                                    <p className="normalText left">
                                      Confirm Password:
                                    </p>
                                    <input
                                      type="text"
                                      value={confirmPassword}
                                      onChange={(event) => {
                                        setConfirmPassword(event.target.value)
                                      }}
                                      name="phonenumber"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 offset-3">
                                  <button
                                    type="button"
                                    className="primary-btn fwidth"
                                    onClick={updateUser}
                                  >
                                    {' '}
                                    Save{' '}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div
                        id="pane-Review"
                        className="card tab-pane fade"
                        role="tabpanel"
                        aria-labelledby="tab-Review"
                      >
                        <div
                          className="card-header"
                          role="tab"
                          id="heading-Review"
                        >
                          <h5 className="mb-0">
                            {/* <!-- Note: `data-parent` removed from here --> */}
                            <a
                              data-toggle="collapse"
                              href="#collapse-Review"
                              aria-expanded="true"
                              aria-controls="collapse-Review"
                            >
                              Review
                            </a>
                          </h5>
                        </div>
                        {/* <!-- Note: New place of `data-parent` --> */}
                        <div
                          id="collapse-Review"
                          className="collapse"
                          data-parent="#content"
                          role="tabpanel"
                          aria-labelledby="heading-Review"
                        >
                          <div className="card-body">
                            <div className="row category-listing">
                              {orderHistories ? (
                                orderHistories.map((item, index) => {
                                  const driverRating =
                                    item.order_details?.review?.filter((el) => {
                                      return el.type === 1
                                    })[0]
                                  const restaurantRating =
                                    item.order_details?.review?.filter((el) => {
                                      return el.type === 0
                                    })[0]
                                  return item.order_details?.status !==
                                    'delivered' &&
                                    item.order_details?.status !==
                                      'dispatched' ? (
                                    <div key={'orderhistory' + index}></div>
                                  ) : (
                                    <div
                                      className="col-lg-12 col-md-12 col-sm-12 col-12"
                                      key={'orderhistory' + index}
                                    >
                                      <div
                                        className="category-item"
                                        style={{
                                          alignItems: 'initial',
                                          padding: 5,
                                        }}
                                      >
                                        <div
                                          className="left"
                                          style={{
                                            background:
                                              `ghostwhite url(` +
                                              K.imageBaseUlr +
                                              `img/` +
                                              item.order_details?.restaurantdata
                                                ?.image +
                                              `)`,
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            width: '50%',
                                            height: '150px',
                                            // borderTop: '1px solid #BDBCBC',
                                            // borderBottom: '1px solid #BDBCBC',
                                            // borderTopLeftRadius: '8px',
                                            // borderBottomLeftRadius: '8px',
                                          }}
                                        ></div>

                                        <div className="right rateee">
                                          <div className="rightContent">
                                            <table style={{ width: '100%' }}>
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <span>Order ID: </span>
                                                  </td>
                                                  <td>
                                                    <b>
                                                      #{item.order_details?.id}
                                                    </b>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>
                                                    <span>Restaurant: </span>
                                                  </td>
                                                  <td>
                                                    <b>
                                                      {
                                                        item.order_details
                                                          ?.restaurantdata
                                                          ?.rname
                                                      }
                                                    </b>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>
                                                    <span>Rating: </span>
                                                  </td>
                                                  <td>
                                                    <Rating
                                                      style={{
                                                        verticalAlign: 'middle',
                                                      }}
                                                      size="small"
                                                      name="read-only"
                                                      value={
                                                        (restaurantRating?.score +
                                                          driverRating?.score) /
                                                        2.0
                                                      }
                                                      precision={0.5}
                                                      readOnly
                                                    />
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td></td>
                                                  <td>
                                                    <button
                                                      className={'primary-btn'}
                                                      style={{
                                                        minWidth: 100,
                                                        marginTop: 20,
                                                      }}
                                                      onClick={() => {
                                                        setCurrentOrder(item)
                                                        if (
                                                          item.order_details
                                                            ?.review &&
                                                          item.order_details
                                                            ?.review.length > 0
                                                        ) {
                                                          setCurrentRating({
                                                            restaurant: {
                                                              score:
                                                                restaurantRating?.score,
                                                              description:
                                                                restaurantRating?.description,
                                                            },
                                                            driver: {
                                                              score:
                                                                driverRating?.score,
                                                              description:
                                                                driverRating?.description,
                                                            },
                                                          })
                                                        } else {
                                                          setCurrentRating({
                                                            restaurant: {
                                                              score: 0,
                                                              description: '',
                                                            },
                                                            driver: {
                                                              score: 0,
                                                              description: '',
                                                            },
                                                          })
                                                        }
                                                      }}
                                                    >
                                                      {driverRating?.id ||
                                                      restaurantRating?.id
                                                        ? 'Edit Rating'
                                                        : 'Rate'}
                                                    </button>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })
                              ) : (
                                <div className="noOrders">
                                  <h5 className="noOrdersHead Spaced">
                                    Opps!, You can&apos;t review any meals yet.
                                  </h5>
                                  <p className="normalText Spaced">
                                    Order your favourite meals from your <br />
                                    local{' '}
                                    <b className="colorgreen">
                                      Restaurants
                                    </b>{' '}
                                    and review them here
                                  </p>
                                  <img
                                    src="/noOrders.svg"
                                    className="img img-responsive Spaced"
                                    style={{ width: '300px' }}
                                  />
                                  <p className="normalText Spaced">
                                    All meals available for review will appear
                                    here...
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Cart logOut={props.logOut} resinfo={resinfo} />
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={currentOrder !== null}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className={
          theme && theme === 'DARK'
            ? 'modal_confirm_order_dark'
            : 'modal_confirm_order_light'
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>How was the food?</h5>
          <Rating
            name="simple-controlled"
            value={currentRating.restaurant.score}
            onChange={(event, newValue) => {
              setCurrentRating((prevState) => ({
                ...prevState,
                restaurant: {
                  ...prevState.restaurant,
                  score: newValue,
                },
              }))
            }}
          />
          <textarea
            placeholder="Description (optional)"
            value={currentRating.restaurant.description}
            id={'description'}
            onChange={(e) => {
              setCurrentRating((prevState) => ({
                ...prevState,
                restaurant: {
                  ...prevState.restaurant,
                  description: e.target.value,
                },
              }))
            }}
            rows="4"
          />
          <h5>How was the roadie?</h5>
          <Rating
            name="simple-controlled"
            value={currentRating.driver.score}
            onChange={(event, newValue) => {
              setCurrentRating((prevState) => ({
                ...prevState,
                driver: {
                  ...prevState.driver,
                  score: newValue,
                },
              }))
            }}
          />
          <textarea
            placeholder="Description (optional)"
            value={currentRating.driver.description}
            id={'description'}
            onChange={(e) => {
              setCurrentRating((prevState) => ({
                ...prevState,
                driver: {
                  ...prevState.driver,
                  description: e.target.value,
                },
              }))
            }}
            rows="4"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Back
          </Button>
          <Button variant="primary" onClick={performRateItem}>
            {'Confirm'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default MyAccount
